import orderApi from '_api/order'
import useQuery from '_hooks/useQuery'
import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { useToasts } from 'react-toast-notifications'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { FaTruck } from 'react-icons/fa'
import { FiLayers } from 'react-icons/fi'
import { callNewListOrder } from '_redux/modules/event'
import { clearDataPurchaseDetailByEid } from '_redux/modules/order'
import {
  BUYER_ORDER_CANCELED,
  BUYER_ORDER_UNPAID,
  BUYER_PAID,
  BUYER_REFUNDED,
  HOST_ORDER_CANCELED,
  HOST_ORDER_UNPAID,
  SELECTION_MODE_SINGLE,
  SINGAPORE_CODE_NO_ADD,
  PAYMENT_METHOD_HIT_PAY,
} from '_utils/constant'
import { useCombinedPaymentOrders } from '../ManageOrder/hooks'
import { isOrderRefunded } from '../ManageOrder/helpers'
import OrderItemRow from './OrderItemRow'

const unverifiedOrdersByHost = [HOST_ORDER_CANCELED, HOST_ORDER_UNPAID]
const ordersIncomplete = [BUYER_REFUNDED, BUYER_ORDER_CANCELED, BUYER_ORDER_UNPAID]

export default function ModalDetailOrder({
  id,
  order,
  modalDetailOrder,
  toggleDetailOrder,
  handleOpenWarning,
  setTimeRender,
  products = [],
}) {
  const history = useHistory()
  const dispatch = useDispatch()
  const { addToast } = useToasts()
  const query = useQuery()
  const isByAdmin = query.get('isByAdmin') === 'true'

  const [messageNoteUpdate, setMessageNoteUpdate] = useState('')
  const [canEdit, setCanEdit] = useState(false)
  const [canCancel, setCanCancel] = useState(false)

  const {
    combinedOrders,
    isLoadingCombined: loadingCombined,
    totalCombinedAmount,
    hitpaySummary,
    isCombined,
  } = useCombinedPaymentOrders(order, { enabled: modalDetailOrder })

  const isPaidTogether = Boolean(
    isCombined ||
      order?.combinedPaymentRef ||
      (combinedOrders && combinedOrders.length > 0) ||
      (order?.listCombinedOrder && order.listCombinedOrder.length > 0)
  )

  const isHitPay =
    order?.paymentType === PAYMENT_METHOD_HIT_PAY || Boolean(hitpaySummary)

  const onChangeNote = async (e, ref) => {
    const _data = e.target.value

    if (isByAdmin) {
      addToast('You are not allowed to update order', { appearance: 'error', autoDismiss: true })
      return
    }

    try {
      await orderApi.updateOrderBuyerInfo(ref, { comment: _data })
      dispatch(callNewListOrder())
      dispatch(clearDataPurchaseDetailByEid(id))
      setMessageNoteUpdate('Updated')
      setTimeRender((prevState) => prevState + 1)
    } catch (error) {
      const { msgResp } = error
      setMessageNoteUpdate(`Error: ${msgResp}`)
    }
  }
  const handleEditOrder = (e, _order) => {
    e.preventDefault()
    history.push(`/event/detail?eid=${id}&&oid=${_order?.ref}`)
  }

  useEffect(() => {
    setTimeout(() => {
      setMessageNoteUpdate('')
    }, 3000)
  }, [messageNoteUpdate])

  useEffect(() => {
    setCanEdit(false)
    setCanCancel(false)
    if (order?.status && order?.buyerStatus) {
      if (
        unverifiedOrdersByHost.includes(order.status) &&
        ordersIncomplete.includes(order.buyerStatus)
      ) {
        setCanEdit(true)
      }
      if (order?.status !== HOST_ORDER_CANCELED) {
        setCanCancel(true)
      }
    }
  }, [order?.status, order?.buyerStatus])

  const ordersWithSplitCaseFlag = order?.allProductPerOrder?.map((item) => {
    const product = products.find((p) => p.id === item.pid)
    const isSplitcase =
      product && product.splitCasePurchase && Object.keys(product.splitCasePurchase).length > 0

    const basePrice =
      item.pPriceNoSubItems !== undefined && item.pPriceNoSubItems !== null
        ? item.pPriceNoSubItems
        : item.pPrice || 0

    const isSingleTrackInventory =
      (item.pSubItemSelectionMode === SELECTION_MODE_SINGLE &&
        Boolean(item.pSubItemTrackInventory)) ||
      Boolean(
        product?.subItems?.some(
          (g) =>
            g.trackInventory === true && g.selectionMode === SELECTION_MODE_SINGLE
        )
      )

    return {
      ...item,
      isSplitcase,
      basePrice,
      hasChooseQuantities: isSingleTrackInventory,
      isSingleTrackInventory,
      product,
    }
  })

  return (
    <div>
      <Modal
        isOpen={modalDetailOrder}
        toggle={toggleDetailOrder}
        centered
        className='modal-detail-order'
        style={{ fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif" }}
      >
        <ModalHeader style={{ padding: '16px 20px', borderBottom: '1px solid #f1f5f9', width: '100%', display: 'flex', flexDirection: 'column' }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              width: '100%',
              marginBottom: '12px',
            }}
          >
            <span
              style={{ fontSize: '13px', color: '#64748b', fontWeight: 500 }}
            >
              Ref: <span id='orderNo' style={{ fontWeight: 600, color: '#334155' }}>{order?.ref?.substring(0, 4)}</span>
            </span>
            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
              {canEdit ? (
                <button
                  type='button'
                  onClick={(e) => handleEditOrder(e, order)}
                  style={{
                    fontSize: '12px',
                    color: '#0284c7',
                    background: '#e0f2fe',
                    border: 'none',
                    borderRadius: '6px',
                    padding: '4px 10px',
                    cursor: 'pointer',
                    fontWeight: 500,
                  }}
                >
                  Edit Order
                </button>
              ) : null}
              {canCancel && !isHitPay ? (
                <button
                  type='button'
                  onClick={(e) => handleOpenWarning(e, order)}
                  style={{
                    fontSize: '12px',
                    color: '#ef4444',
                    background: '#fef2f2',
                    border: 'none',
                    borderRadius: '6px',
                    padding: '4px 10px',
                    cursor: 'pointer',
                    fontWeight: 500,
                  }}
                >
                  Cancel Order
                </button>
              ) : null}
            </div>
          </div>
          <div className='welcome-group welcome-group--white' style={{ marginTop: '4px' }}>
            <div className='welcome-group__img'>
              <div className='c-image-edit'>
                <div className='c-image' style={{ justifyContent: 'center' }}>
                  <img
                    width='100%'
                    height='100%'
                    id='userPhotoUrl'
                    src={
                      order.uPhotoUrl
                        ? order.uPhotoUrl
                        : process.env.REACT_APP_AVATAR_URL + order?.uName
                    }
                    alt=''
                  />
                </div>
                <a
                  id='userWhatsapp'
                  href={`https://wa.me/${SINGAPORE_CODE_NO_ADD}${order?.uPhone}`}
                  target='_blank'
                  rel='noreferrer'
                >
                  <span className='icon-whatapp' />
                </a>
              </div>
            </div>
          </div>
          <p className='text-center mt-2 mb-1' style={{ margin: 0 }}>
            <span style={{ fontWeight: '700', fontSize: '1.1rem', color: '#ff6903', display: 'block' }}>{order?.uName}</span>
            <small id='userPhone' style={{ color: '#ff6903', fontSize: '0.9rem', fontWeight: 500 }}>{order?.uPhone}</small>
          </p>
          <div className='d-flex flex-wrap justify-content-center gap-3 mt-1' style={{ fontSize: '12px', color: '#94a3b8' }}>
            {Boolean(order?.createdAt) && (
              <span>
                Ordered: {new Date(order.createdAt * 1000).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })}
              </span>
            )}
            {Boolean(order?.lastModifiedAt) && (
              <span>
                Updated: {new Date(order.lastModifiedAt * 1000).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })}
              </span>
            )}
          </div>
        </ModalHeader>

        <ModalBody style={{ padding: '16px 20px', border: 0 }}>
          {/* Products List Box */}
          <div style={{ backgroundColor: '#fafafa', borderRadius: '12px', padding: '14px 16px', marginBottom: '16px', border: '1px solid #f1f5f9' }}>
            <h4 style={{ fontSize: '13px', fontWeight: 700, color: '#475569', textTransform: 'uppercase', marginBottom: '12px', letterSpacing: '0.5px' }}>
              Items Summary
            </h4>
            {ordersWithSplitCaseFlag && ordersWithSplitCaseFlag.length > 0
              ? ordersWithSplitCaseFlag.map((item, _index) => (
                  <OrderItemRow
                    key={_index}
                    item={item}
                    isLast={_index === ordersWithSplitCaseFlag.length - 1}
                    products={products}
                  />
                ))
              : null}
          </div>
          {/* Pay Together Combined Orders Box */}
          {combinedOrders && combinedOrders.length > 0 ? (
            <div
              style={{
                backgroundColor: '#fafafa',
                borderRadius: '12px',
                padding: '14px 16px',
                marginBottom: '16px',
                border: '1px solid #f1f5f9',
              }}
            >
              <div
                className="d-flex align-items-center justify-content-between mb-3"
                style={{ flexWrap: 'wrap', gap: '8px' }}
              >
                <div className="d-flex align-items-center gap-2" style={{ color: '#ff6903' }}>
                  <FiLayers style={{ fontSize: '16px' }} />
                  <span
                    style={{
                      fontWeight: 700,
                      fontSize: '13px',
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px',
                    }}
                  >
                    Paid Together Orders{' '}
                    {combinedOrders.length > 0 ? `(${combinedOrders.length})` : ''}
                  </span>
                </div>
                {/* <span
                  style={{
                    fontSize: '11px',
                    color: '#64748b',
                    background: '#f1f5f9',
                    padding: '2px 8px',
                    borderRadius: '6px',
                    fontWeight: 500,
                  }}
                >
                  Ref: {order.combinedPaymentRef}
                </span> */}
              </div>

              {loadingCombined ? (
                <div
                  style={{
                    textAlign: 'center',
                    padding: '16px 0',
                    color: '#94a3b8',
                    fontSize: '13px',
                  }}
                >
                  Loading combined orders...
                </div>
              ) : combinedOrders.length > 0 ? (
                <div className="d-flex flex-column gap-3">
                  {combinedOrders.map((cOrder, cIdx) => {
                    const isCurrent = cOrder.ref === order.ref
                    const isRefunded = isOrderRefunded(cOrder)
                    const cProducts = cOrder?.allProductPerOrder || cOrder?.items || []
                    const cTotal =
                      cOrder.totalFee !== undefined
                        ? Number(cOrder.totalFee)
                        : Number(cOrder.totalPricePerOrder) || 0

                    return (
                      <div
                        key={cOrder.ref || cIdx}
                        style={{
                          backgroundColor: isCurrent ? '#fffbf8' : '#ffffff',
                          border: isCurrent ? '1.5px solid #ff6903' : '1px solid #e2e8f0',
                          borderRadius: '10px',
                          padding: '12px 14px',
                          boxShadow: '0 1px 3px rgba(0,0,0,0.02)',
                          opacity: isRefunded && !isCurrent ? 0.8 : 1,
                        }}
                      >
                        {/* Order Header */}
                        <div
                          className="d-flex justify-content-between align-items-center mb-2 pb-2"
                          style={{ borderBottom: '1px solid #f1f5f9' }}
                        >
                          <div className="d-flex align-items-center gap-2 flex-wrap">
                             {isRefunded && (
                              <span
                                style={{
                                  fontSize: '11px',
                                  fontWeight: 700,
                                  color: '#dc2626',
                                  background: '#fee2e2',
                                  border: '1px solid #fecaca',
                                  padding: '1px 6px',
                                  borderRadius: '4px',
                                  textTransform: 'uppercase',
                                  letterSpacing: '0.3px',
                                }}
                              >
                                Refunded
                              </span>
                            )}
                            <span
                              style={{
                                fontSize: '11px',
                                fontWeight: 700,
                                background: isCurrent ? '#ff6903' : '#f1f5f9',
                                color: isCurrent ? '#ffffff' : '#475569',
                                padding: '2px 7px',
                                borderRadius: '4px',
                              }}
                            >
                              Order #{cOrder.eOrderNo}
                            </span>
                            <span
                              style={{
                                fontSize: '13px',
                                fontWeight: 600,
                                color: '#1e293b',
                              }}
                              title={cOrder.eTitle}
                            >
                              {cOrder.eTitle}
                            </span>
                            {isCurrent && (
                              <span
                                style={{
                                  fontSize: '11px',
                                  fontWeight: 600,
                                  color: '#ff6903',
                                  background: '#fff3eb',
                                  padding: '1px 6px',
                                  borderRadius: '4px',
                                }}
                              >
                                Current
                              </span>
                            )}
                          </div>
                          <div
                            style={{
                              fontSize: '13px',
                              fontWeight: 700,
                              color: isRefunded ? '#94a3b8' : '#0f172a',
                            }}
                          >
                            ${cTotal.toFixed(2)}
                          </div>
                        </div>

                        {/* Order Products */}
                        <div className="d-flex flex-column">
                          {cProducts.map((p, pIdx) => (
                            <OrderItemRow
                              key={pIdx}
                              item={p}
                              isLast={pIdx === cProducts.length - 1}
                              products={products}
                            />
                          ))}
                        </div>

                        {/* Fee chips */}
                        <div
                          className="d-flex flex-wrap gap-2 mt-2 pt-2"
                          style={{
                            borderTop: '1px dashed #f1f5f9',
                            fontSize: '11px',
                            color: '#64748b',
                          }}
                        >
                          <span
                            style={{
                              background: '#f8fafc',
                              padding: '2px 6px',
                              borderRadius: '4px',
                              border: '1px solid #f1f5f9',
                            }}
                          >
                            Admin: ${Number(cOrder?.adminCostPerOrder || 0).toFixed(2)}
                          </span>
                          <span
                            style={{
                              background: '#f8fafc',
                              padding: '2px 6px',
                              borderRadius: '4px',
                              border: '1px solid #f1f5f9',
                            }}
                          >
                            Delivery: ${Number(cOrder?.deliveryPerOrder || 0).toFixed(2)}
                          </span>
                          {Number(cOrder?.discountPerOrder) > 0 && (
                            <span
                              style={{
                                background: '#ecfdf5',
                                color: '#059669',
                                padding: '2px 6px',
                                borderRadius: '4px',
                                border: '1px solid #a7f3d0',
                                fontWeight: 500,
                              }}
                            >
                              Discount: -${Number(cOrder?.discountPerOrder).toFixed(2)}
                            </span>
                          )}
                        </div>
                      </div>
                    )
                  })}

                  {/* Combined Total Summary */}
                  <div
                    style={{
                      borderTop: '1px solid #e2e8f0',
                      marginTop: '6px',
                      paddingTop: '8px',
                    }}
                  >
                    <div className="d-flex justify-content-between align-items-center mb-1">
                      <span style={{ fontSize: '12px', fontWeight: 600, color: '#64748b' }}>
                        Combined Total ({combinedOrders.length} orders):
                      </span>
                      <span style={{ fontSize: '14px', fontWeight: 700, color: '#ff6903' }}>
                        ${totalCombinedAmount.toFixed(2)}
                      </span>
                    </div>

                    {hitpaySummary && (
                      <>
                        <div className="d-flex justify-content-between align-items-center mb-1">
                          <span style={{ fontSize: '12px', color: '#64748b' }}>
                            Platform Fee{' '}
                            {hitpaySummary.commissionPercentage
                              ? `(${hitpaySummary.commissionPercentage}%)`
                              : ''}
                            :
                          </span>
                          <span
                            style={{
                              fontSize: '12px',
                              fontWeight: 600,
                            }}
                          >
                            ${hitpaySummary.commissionAmount.toFixed(2)}
                          </span>
                        </div>
                        <div
                          className="d-flex justify-content-between align-items-center pt-1"
                          style={{ borderTop: '1px dashed #e2e8f0' }}
                        >
                          <span
                            style={{
                              fontSize: '12px',
                              fontWeight: 600,
                              color: '#15803d',
                            }}
                          >
                            Seller Net Earnings:
                          </span>
                          <span
                            style={{
                              fontSize: '13px',
                              fontWeight: 700,
                              color: '#15803d',
                            }}
                          >
                            ${hitpaySummary.netAmount.toFixed(2)}
                          </span>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              ) : (
                <div
                  style={{
                    textAlign: 'center',
                    padding: '12px 0',
                    color: '#94a3b8',
                    fontSize: '13px',
                  }}
                >
                  No other orders in this combined payment
                </div>
              )}
            </div>
          ) : null}
          {/* Delivery Info Box */}
          {order?.bookingAddress ? (
            <div style={{ backgroundColor: '#f0fdfa', borderRadius: '12px', padding: '14px 16px', marginBottom: '16px', border: '1px solid #ccfbf1' }}>
              <div className="d-flex align-items-center gap-2 mb-2" style={{ color: '#0d9488' }}>
                <FaTruck style={{ fontSize: '16px' }}/>
                <span style={{ fontWeight: 700, fontSize: '13px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Delivery Details</span>
              </div>
              <div style={{ fontSize: '14px', color: '#334155' }}>
                {order?.deliveryDate ? (
                  <p className='mb-1'><strong>Date:</strong> {order.deliveryDate}</p>
                ) : null}
                <p className='mb-1'><strong>Address:</strong> {order.bookingAddress}</p>
                {order?.consignee ? (
                  <p className='mb-1'><strong>Consignee:</strong> {order.consignee}</p>
                ) : null}
                {order?.phoneConsignee ? (
                  <p className='mb-0'><strong>Phone:</strong> {order.phoneConsignee}</p>
                ) : null}
              </div>
            </div>
          ) : null}

          {/* Note Box */}
          <div>
            <label htmlFor='comment2' style={{ fontWeight: 700, fontSize: '12px', color: '#ff6903', letterSpacing: '0.5px', marginBottom: '6px', display: 'block' }}>
              NOTE
            </label>
            <textarea
              id='comment2'
              cols={30}
              rows={2}
              className='form-control'
              style={{ borderRadius: '8px', border: '1px solid #cbd5e1', fontSize: '15px', padding: '10px 12px' }}
              onBlur={(e) => onChangeNote(e, order?.ref)}
              defaultValue={order.comment}
              placeholder='Add a note for this order...'
            />
            {messageNoteUpdate && (
              <span id='commentUpdated' style={{ color: '#0d9488', fontSize: '12px', fontWeight: 500, marginTop: '4px', display: 'inline-block' }}>
                ✓ {messageNoteUpdate}
              </span>
            )}
          </div>
        </ModalBody>

        <ModalFooter
          style={{
            fontSize: '14px',
            fontWeight: 600,
            padding: '16px 20px',
            borderTop: '1px solid #f1f5f9',
            backgroundColor: '#fafafa',
            borderRadius: '0 0 12px 12px',
            justifyContent: 'flex-end',
          }}
        >
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'auto auto',
              columnGap: '12px',
              rowGap: '2px',
              alignItems: 'center',
            }}
          >
            {!isPaidTogether && (
              <>
                <div style={{ textAlign: 'right', color: '#ff6903' }}>
                  Total Purchase:
                </div>
                <div style={{ textAlign: 'right', color: '#ff6903' }}>
                  {order?.discountPerOrder ? (
                    <>
                      <span style={{ textDecoration: 'line-through', marginRight: '6px' }}>
                        {/* eslint-disable-next-line max-len */}
                        ${((order?.totalPricePerOrder || 0) + (order?.adminCostPerOrder || 0)).toFixed(2)}
                      </span>
                      <span id='amount'>
                        ${order?.totalFee?.toFixed(2)}
                      </span>
                    </>
                  ) : (
                    <span id='amount'>
                      ${order?.totalFee?.toFixed(2)}
                    </span>
                  )}
                </div>

                {hitpaySummary && order?.paymentType === PAYMENT_METHOD_HIT_PAY && (
                  <>
                    <div style={{ textAlign: 'right' }}>
                      Platform Fee {hitpaySummary.commissionPercentage ? `(${hitpaySummary.commissionPercentage}%)` : ''}:
                    </div>
                    <div style={{ textAlign: 'right' }}>
                      ${hitpaySummary.commissionAmount.toFixed(2)}
                    </div>

                    <div style={{ textAlign: 'right', color: '#15803d' }}>
                      Seller Net Earnings:
                    </div>
                    <div style={{ textAlign: 'right', color: '#15803d' }}>
                      ${hitpaySummary.netAmount.toFixed(2)}
                    </div>
                  </>
                )}
              </>
            )}

            <div style={{ textAlign: 'right' }}>
              Payment Made:
            </div>
            <div style={{ textAlign: 'right' }}>
              <span
                id='paymentStatus'
                style={{
                  fontSize: '13px',
                  padding: '3px 10px',
                  borderRadius: '12px',
                  backgroundColor: order.buyerStatus >= BUYER_PAID ? '#dcfce7' : '#ffedd5',
                  color: order.buyerStatus >= BUYER_PAID ? '#15803d' : '#c2410c',
                  display: 'inline-block',
                }}
              >
                {order.buyerStatus >= BUYER_PAID ? 'Paid' : 'Unpaid'}
              </span>
            </div>
          </div>
        </ModalFooter>
      </Modal>
    </div>
  )
}
